module.exports = __webpack_public_path__ + "img/consult_info3.79940d82.png";